import gql from 'graphql-tag';

export default gql`
  mutation ($_id: MongoID!) {
    removeContentGroup(_id: $_id) {
      recordId
    }
  }
`;
